import { render, staticRenderFns } from "./salespostgrp.vue?vue&type=template&id=06ca6680"
import script from "./salespostgrp.vue?vue&type=script&lang=js"
export * from "./salespostgrp.vue?vue&type=script&lang=js"
import style0 from "./salespostgrp.vue?vue&type=style&index=0&id=06ca6680&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports